module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 20h-4c-1.106 0-2 .894-2 2v3a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3c0-1.106-.894-2-2-2H4V4h24v16zm-17-8h3V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-3.js
// module id = 1185
// module chunks = 14